import React, { Component, useEffect, useState } from 'react'
import {Box, Card, Paper,Grid,Divider, Typography,IconButton,Checkbox, Button} from '@mui/material'

import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import AccountCircle from '@mui/icons-material/AccountCircle';
import PersonIcon from '@mui/icons-material/Person';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';
import base from './base.json'
import './css/login.css'

import { useNavigate,useLocation, Link } from 'react-router-dom';
//import base_url from '../base'
function Login(props) {
  const navigate = useNavigate()
  const location = useLocation()

  const [showpassword,SetshowPassword] =useState(true);
  const [username,Setusername] =useState("");
  const [password,Setpassword] =useState("");



useEffect(()=>{
 
if(location.pathname==="/"){
//props.cl();
}
},[])




 function login(){


    fetch(`${base.base_url}/property_portal/vendor_portal/builder/loginBuilder`, {
      headers:{
        'authorization': `Bearer ${sessionStorage.getItem('token')}`,
    'content-type':'application/json',
   // 'Access-Control-Allow-Origin': 'http://localhost:3000',
      },
          method: "post",
          body:JSON.stringify({
                      builder_email_id: username,
                      builder_login_passcode: password,
            })
  
        }).then(function(response) {
          return response.json();
        })
        .then(async(data)=> {

         if(data.status){
          await sessionStorage.setItem('data',JSON.stringify(data.data))
           window.open("/main","_self")
         }else{
          alert("Authentication failed")
         }
        });
      
  }



  return (
    <div class='rr'>
    <div class="container">
<div class="login-wrapper">


    <section class="image-section">

        <div class="logo">
            <div class="logo-icon">
                <i class="fa-solid fa-house"></i>
            </div>
            Makaan Media
        </div>

        <div class="hero-content">

            <div class="small-title">
                Your property journey starts here
            </div>

            <h1>
                Find a place you'll love to call home.
            </h1>

            <p>
                Discover premium homes, apartments and commercial
                properties from trusted agents and verified owners.
            </p>

        </div>

        <div class="property-card">

            <div class="house-icon">
                <i class="fa-solid fa-building"></i>
            </div>

            <div>
                <strong>25,000+ Properties</strong>
                <span>Available across India</span>
            </div>

        </div>

    </section>


    <section class="login-section">

        <div class="login-box">

            <div class="login-heading">

                <div class="welcome">
                    Welcome Back
                </div>

                <h2>
                    Login to your account
                </h2>

                <p>
                    Access your properties, enquiries and saved listings.
                </p>

            </div>


            <div >

                

                <div class="form-group">

                    <label>Email Address</label>

                    <div class="input-box">

                        <i class="fa-regular fa-envelope"></i>

                        <input
                            type="email"
                            id="email"
                            value={username}
                            onChange={(e)=>Setusername(e.target.value)}

                            placeholder="Enter your email address"
                            required
                        />

                    </div>

                </div>



                <div class="form-group">

                    <label>Password</label>

                    <div class="input-box">

                        <i class="fa-solid fa-lock"></i>

                        <input
                            type="password"
                            id="password"
                            value={password}
                              onChange={(e)=>Setpassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />

                        <i
                            class="fa-regular fa-eye password-toggle"
                            onclick="togglePassword()"
                            id="eyeIcon">
                        </i>

                    </div>

                </div>


             

                <div class="form-options">

                    <label class="remember">

                        <input type="checkbox"/>

                        Remember me

                    </label>

                    <a href="#" class="forgot">
                        Forgot Password?
                    </a>

                </div>


             
                <button class="login-btn" onClick={login} type="submit">

                    Login to Portal

                    <i class="fa-solid fa-arrow-right"></i>

                </button>

            </div>


        
            <div class="divider">
                OR CONTINUE WITH
            </div>


          

     

            <div class="register-text">

                Don't have an account?

                <a href="/register">
                    Create Account
                </a>

            </div>


            <div class="security">

                <i class="fa-solid fa-shield-halved"></i>

                Your information is securely encrypted

            </div>

        </div>

    </section>

</div>
          </div>
          </div>
  )
}

export default Login






























